import { EFFECTS_URL, type BattleAnimation } from '../../shared/moves.ts';
import { assetImage } from './element-renderer.ts';

/** Animations d'attaque connues, reçues du serveur (jeu) ou de l'API (administration). */
let catalog = new Map<number, BattleAnimation>();

export const animationCatalog = {
  set(animations: readonly BattleAnimation[]): void {
    catalog = new Map(animations.map((animation) => [animation.id, animation]));
  },
  get: (id: number): BattleAnimation | undefined => catalog.get(id),
  all: (): BattleAnimation[] => [...catalog.values()],
};

/** Planche d'effets d'une animation (chargée une fois). */
export const effectSheet = (animation: Pick<BattleAnimation, 'image'>): HTMLImageElement => assetImage(EFFECTS_URL, animation.image);

/**
 * Dessine l'image n° `frame` de l'animation dans le rectangle (x, y, w, h), en gardant ses proportions
 * (centrée). Ne dessine rien tant que la planche charge.
 */
export function drawAnimationFrame(ctx: CanvasRenderingContext2D, animation: BattleAnimation, frame: number, x: number, y: number, w: number, h: number): void {
  const sheet = effectSheet(animation);
  const source = animation.frames[frame];
  if (!source || !sheet.complete || !sheet.naturalWidth) return;
  const scale = Math.min(w / animation.width, h / animation.height);
  const dw = animation.width * scale, dh = animation.height * scale;
  ctx.imageSmoothingEnabled = scale < 1;
  ctx.drawImage(sheet, source.x, source.y, animation.width, animation.height, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
}
